const config = {
  brand: { brand: 'tresemme', locale: 'en-US', division: 'bpc', version: 'v1', journey_type: 'vto' },

  productRecommendation: {
    categories: [
      {
        name: 'hair',
        noOfProductsPerRoutine: 1,
        sections: [
          { name: 'regime', routine: ['wash', 'condition', 'styling'] },
          { name: 'how to', routine: ['treatment'] },
        ],
      },
    ],
  },
  articleRecommendation: {
    categories: [
      {
        name: 'Hair',
        noOfProductsPerRoutine: 2,
        sections: [
          {
            name: 'condition',
            routine: ['shampoo', 'conditioner', 'dry shampoo', 'treatments'],
          },
        ],
      },
    ],
    limit: 10,
  },
  profileStore: {
    api: 'formV3',
    formV3: {
      url: 'https://forms-us.unileversolutions.com/v3',
      epsUrl: 'API_URL_FORM_V3_EPS',
      header: {
        originatingCampaign: 'Tresemme 2023 - Virtual Try On',
        originatingSource: 'Tresemme 2023 - Virtual Try On',
        isoLanguage: 'EN',
        isoCountry: 'IN',
        formType: 'signUp',
        entity: 'epsilon',
        origin: 'https://www.tresemme.com/us/en/home.html',
        brandCode: 'BH0996',
        campaignId: '9100000156',
        campaignDescription: 'always on',
        localCampaignId: '9100000156',
        formId: '835c43c2-b755-11ed-afa1-0242ac120002',
        localFormId: '3000000041',
      },
      additionalSubscription: {
        brandEmailConsentOptins: '9100000157',
        unileverEmailConsentOptins: '9000001779',
        healthConsentOptins: '5000016229',
      },
      apiKey: 'API_KEY_FORMV3',
    },
  },
  brandInfo: {
    brandname: 'ahc',
    bransiteurl: 'http:ahc',
    bransite: 'ahc brandsite',
    brandphoneNumber: '9999999999',
  },
  buyItNow: {
    api: 'mikmak',
    cartwire: {
      url: 'https://s3.cartwire.co/widget/js/widget_master_v2.js',
      theme: 'retailPopup',
      locale: 'en',
    },
    pricespider: {
      url: 'https://cdn.pricespider.com/1/lib/ps-widget.js',
      versionUrl: 'https://cdn.pricespider.com/1/lib/2.3.99/ps-widget.js',
      trackUrl: 'https://cdn.pricespider.com/1/1750/ps-utid.js',
      key: 'API_KEY_PRICE_SPIDER',
      language: 'en',
      country: 'US',
    },
    mikmak: {
      appId: 'MIKMAK_APP_ID',
      label: 'Buy It Now',
    },
  },
  apiConfig: {
    baseUrl: 'AIBA_SERVICES_BASE_URL',
    apiUrl: {
      feedback: 'feedback',
    },
    apiKey: 'API_KEY_AIBA_SERVICES',
    apiEndpoints: {
      haut: {
        analyse: 'AIBA_SERVICES_HAUT_ANALYZE_PATH',
        results: 'AIBA_SERVICES_HAUT_RESULTS_PATH',
      },
      recommendations: 'AIBA_SERVICES_RECOMMENDATIONS_PATH',
      weather: 'AIBA_SERVICES_WEATHER_PATH',
      feedback: 'AIBA_SERVICES_FEEDBACK_PATH',
      pdfmailer: 'AIBA_SERVICES_PDFMAILER_PATH',
    },
  },
  pdfTemplateURLs: {
    footer: `PDF_TEMPLATE_URL_FOOTER`,
    header: `PDF_TEMPLATE_URL_HEADER`,
    mail: `PDF_MAIL_TEMPLATE_JSON`,
    body: `PDF_TEMPLATE_URL_BODY`,
  },
  vtoConfig: {
    skinSmoothStrength: 1,
    language: 'en',
    userConsent: 'agree',
    enableWhatsAppSharing: false,
  },
  getSelectedStyles: {
    HAIR_STYLE_01_88: { answerId: '3100000068', surveyQuestionAnswerId: '5100000492' },
    HAIR_STYLE_01_85: { answerId: '3100000227', surveyQuestionAnswerId: '5100000543' },
    HAIR_STYLE_01_79: { answerId: '3100000222', surveyQuestionAnswerId: '5100000519' },
    HAIR_STYLE_01_65: { answerId: '3100000236', surveyQuestionAnswerId: '5100000547' },
    HAIR_STYLE_01_81: { answerId: '3100000233', surveyQuestionAnswerId: '5100000533' },
    HAIR_STYLE_01_05: {
      answerId: '3100000226',
      surveyQuestionAnswerId: '5100000253',
    },
    HAIR_STYLE_01_82: { answerId: '3100000224', surveyQuestionAnswerId: '5100000522' },
    HAIR_STYLE_01_99: { answerId: '3100000069', surveyQuestionAnswerId: '5100000505' },
    HAIR_STYLE_01_83: { answerId: '3100000228', surveyQuestionAnswerId: '5100000525' },
    HAIR_STYLE_01_100: {
      answerId: '3100000232',
      surveyQuestionAnswerId: '5100000532',
    },
    HAIR_STYLE_01_80: {
      answerId: '3100000223',
      surveyQuestionAnswerId: '5100000518',
    },
    HAIR_STYLE_01_92: { answerId: '3100000234', surveyQuestionAnswerId: '5100000546' },
    HAIR_STYLE_01_90: { answerId: '3100000235', surveyQuestionAnswerId: '5100000538' },
    HAIR_STYLE_01_91: { answerId: '3100000225', surveyQuestionAnswerId: '5100000539' },
    HAIR_STYLE_01_06: { answerId: '3100000229', surveyQuestionAnswerId: '5100000526' },
    HAIR_STYLE_01_98: {
      answerId: '3100000231',
      surveyQuestionAnswerId: '5100000531',
    },
    HAIR_STYLE_01_87: {
      answerId: '3100000230',
      surveyQuestionAnswerId: '5100000530',
    },
    HAIR_STYLE_01_89: { answerId: '3100000240', surveyQuestionAnswerId: '5100000554' },
    HAIR_STYLE_01_84: { answerId: '3100000241', surveyQuestionAnswerId: '5100000557' },
    HAIR_STYLE_01_101: { answerId: '3100000239', surveyQuestionAnswerId: '5100000558' },
    HAIR_STYLE_01_86: { answerId: '3100000237', surveyQuestionAnswerId: '5100000550' },
  },
  getStylesIdMappingList: {
    HAIR_STYLE_01_88: { answerId: '3100000068', surveyQuestionAnswerId: '5100000236' },
    HAIR_STYLE_01_85: { answerId: '3100000227', surveyQuestionAnswerId: '5100000524' },
    HAIR_STYLE_01_79: { answerId: '3100000222', surveyQuestionAnswerId: '5100000517' },
    HAIR_STYLE_01_65: { answerId: '3100000236', surveyQuestionAnswerId: '5100000545' },
    HAIR_STYLE_01_81: { answerId: '3100000233', surveyQuestionAnswerId: '5100000537' },
    HAIR_STYLE_01_05: {
      answerId: '3100000226',
      surveyQuestionAnswerId: '5100000528',
    },
    HAIR_STYLE_01_82: { answerId: '3100000224', surveyQuestionAnswerId: '5100000520' },
    HAIR_STYLE_01_99: { answerId: '3100000069', surveyQuestionAnswerId: '5100000254' },
    HAIR_STYLE_01_83: { answerId: '3100000228', surveyQuestionAnswerId: '5100000542' },
    HAIR_STYLE_01_100: {
      answerId: '3100000232',
      surveyQuestionAnswerId: '5100000535',
    },
    HAIR_STYLE_01_80: {
      answerId: '3100000223',
      surveyQuestionAnswerId: '5100000529',
    },
    HAIR_STYLE_01_92: { answerId: '3100000234', surveyQuestionAnswerId: '5100000536' },
    HAIR_STYLE_01_90: { answerId: '3100000235', surveyQuestionAnswerId: '5100000540' },
    HAIR_STYLE_01_91: { answerId: '3100000225', surveyQuestionAnswerId: '5100000521' },
    HAIR_STYLE_01_06: { answerId: '3100000229', surveyQuestionAnswerId: '5100000541' },
    HAIR_STYLE_01_98: {
      answerId: '3100000231',
      surveyQuestionAnswerId: '5100000544',
    },
    HAIR_STYLE_01_87: {
      answerId: '3100000230',
      surveyQuestionAnswerId: '5100000527',
    },
    HAIR_STYLE_01_89: { answerId: '3100000240', surveyQuestionAnswerId: '5100000555' },
    HAIR_STYLE_01_84: { answerId: '3100000241', surveyQuestionAnswerId: '5100000559' },
    HAIR_STYLE_01_101: { answerId: '3100000239', surveyQuestionAnswerId: '5100000553' },
    HAIR_STYLE_01_86: { answerId: '3100000237', surveyQuestionAnswerId: '5100000556' },
  },
  quizRedirectLink: 'https://www.tresemme.com/us/en/hair-quiz-analyzer.html',
};
export default config;
